import { Modal, Button, Group, ButtonProps } from '@mantine/core';

import { PromiseDialogFactory, RenderModal } from './PromiseDialogFactory';

type DisplayProps = {
  title?: string;
  submitText?: string;
  cancelText?: string;
};

type ConfirmPromiseModalData = boolean;
type ConfirmPromiseModalProps = DisplayProps;

type TPromiseRenderModal = RenderModal<
  ConfirmPromiseModalData,
  ConfirmPromiseModalProps
>;

const ConfirmModal2: TPromiseRenderModal = ({
  onCancel,
  onSubmit,
  isOpen,
  title = '確認要放棄變更？',
  cancelText = '回到編輯',
  submitText = '離開編輯',
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={() => {
        onCancel?.();
      }}
      title={title}
      centered
      withCloseButton={false}
    >
      <Group mt="xl" justify="flex-end">
        <Button
          variant="outline"
          onClick={() => {
            onCancel?.();
          }}
        >
          {cancelText}
        </Button>
        <Button
          color="red"
          onClick={() => {
            onSubmit?.(true);
          }}
        >
          {submitText}
        </Button>
      </Group>
    </Modal>
  );
};

const { useModal: useConfirmModal, Modal: PromiseConfirmModal } =
  PromiseDialogFactory(ConfirmModal2);

export const ConfirmedButton = (
  props: ButtonProps & React.ComponentProps<'button'>,
) => {
  const { props: confirmProps, open } = useConfirmModal();

  return (
    <>
      <PromiseConfirmModal {...confirmProps} />
      <Button
        {...props}
        onClick={async (e) => {
          const ok = await open?.(true);

          if (!ok) return;

          props?.onClick?.(e);
        }}
      />
    </>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export { useConfirmModal, PromiseConfirmModal };
